/** Draws a takeoff tool glyph with react-native-svg (react-native-web on the web). */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { INK, TOOL_GLYPHS, type ToolGlyphName } from './toolGlyphs';

export function ToolGlyphView({ name, size, color }: { name: ToolGlyphName; size: number; color: string }) {
  const glyph = TOOL_GLYPHS[name];
  const paint = (value: string | undefined) => (value === INK ? color : value);
  return (
    <Svg width={size} height={size} viewBox={glyph.viewBox}>
      {glyph.layers.map((layer, index) => (
        <Path
          key={index}
          d={layer.d}
          fill={paint(layer.fill)}
          fillOpacity={layer.fillOpacity}
          stroke={paint(layer.stroke)}
          strokeWidth={layer.strokeWidth}
          strokeLinecap={layer.strokeLinecap}
          strokeLinejoin={layer.strokeLinejoin}
        />
      ))}
    </Svg>
  );
}
